<template>
    <div class="content-area__heading">
            <top-nav>
                <div slot="title">
                    <h2 >Estatísticas</h2>
                </div>
            </top-nav>
            <vx-card v-for="(item,key) in estatisicas" v-bind:key="key+1" :title="item.title" :subtitle="item.subtitle" 
                    collapse-action :refresh-content-action="item.show_refresh" 
                    :download-card-action="item.show_download" :close="true" 
                    v-on:download="function(){ 
                        item.download = true 
                        $nextTick(() => {
                            item.download = false 
                        }) 
                    }" 
                    v-on:refresh="function(){
                        item.refresh = true 
                        $nextTick(() => {
                            item.refresh = false 
                        })
                    }"
                    v-on:toggle="function(close) { 
                        close == false ? item.loading = true : 0 
                        close == false ? item.show_refresh = true : item.show_refresh = false
                        close == false ? 0 : item.show_download = false, 
                        item.close = true
                        $nextTick(() => {
                            item.close = false
                        })}
                    ">
                <div>
                    <estatisticas-detalhes 
                        v-if="item.title=='Bug' && item.loading" 
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status" tipo="bug">
                    </estatisticas-detalhes>
                    <estatisticas-detalhes 
                        v-if="item.title=='Melhorias' && item.loading" 
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status" tipo="mel">
                    </estatisticas-detalhes>
                    <estatisticas-detalhes 
                        v-if="item.title=='Solicitações de Serviços' && item.loading" 
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status" tipo="ss">
                    </estatisticas-detalhes>
                    <estatisticas-detalhes 
                        v-if="item.title=='MVP' && item.loading" 
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status" tipo="mvp">
                    </estatisticas-detalhes>
                    <estatisticas-andamento 
                        v-if="item.title=='Andamento' && item.loading" 
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status">
                    </estatisticas-andamento>
                    <estatisticas-tempo 
                        v-if="item.title=='Média de Tempo' && item.loading" 
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status">
                    </estatisticas-tempo>
                    <estatisticas-analistas
                        v-if="item.title=='Produtividade' && item.loading" 
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status">
                    </estatisticas-analistas>
                    <estatisticas-qualidade
                        v-if="item.subtitle=='Aprovados' && item.loading" 
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status">
                    </estatisticas-qualidade>
                    <estatisticas-qualidade
                        v-if="item.subtitle=='Reprovados' && item.loading" 
                        :refresh="item.refresh" :download="item.download" reprovados 
                        :close="item.close" v-on:download="(status) => item.show_download = status">
                    </estatisticas-qualidade>
                    <estatisticas-reabertura
                        v-if="item.title=='Reabertura' && item.loading" 
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status">
                    </estatisticas-reabertura>
                    <estatisticas-incidentes
                        v-if="item.subtitle=='tickets - erros pré-qualidade' && item.loading" 
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status">
                    </estatisticas-incidentes>
                    <estatisticas-ranque-analistas
                        v-if="item.subtitle=='Ranque - Programador X bug' && item.loading" 
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status">
                    </estatisticas-ranque-analistas>
                </div>
            </vx-card>
    </div>
</template>

<script>
    import {moment, UCfirst} from "../../helpers/utils.js" 
    import {debounce} from "lodash" 

    export default {
        name: "tickets-estatisticas",
        components: {
            EstatisticasAndamento: () => import("./components/estatisticas-andamento.vue"),
            EstatisticasTempo: () => import("./components/estatisticas-tempo.vue"),
            EstatisticasDetalhes: () => import("./components/estatisticas-detalhe.vue"),
            EstatisticasAnalistas: () => import("./components/estatisticas-analistas.vue"),
            EstatisticasQualidade: () => import('./components/estatisticas-qualidade.vue'),
            EstatisticasReabertura: () => import('./components/estatisticas-reabertura.vue'),
            EstatisticasIncidentes: () => import('./components/estatisticas-incidentes.vue'),
            EstatisticasRanqueAnalistas: () => import('./components/estatisticas-ranque-analistas.vue'),
            TopNav: () => import("../../components/nav-bar/top-nav"),
            TableCsv: () => import("../../components/table-csv/TableCsv"),
        },
        data:()=> ({
            estatisicas:{
                bug:{
                    title:"Bug",
                    subtitle:"Tickets",
                    loading:false,
                    refresh:false,
                    download:false,
                    show_download:false,
                    close:false,
                },
                melhoria:{
                    title:"Melhorias",
                    subtitle:"Tickets",
                    loading:false,
                    refresh:false,
                    download:false,
                    show_download:false,
                    close:false,
                },
                solicitacao_servico:{
                    title:"Solicitações de Serviços",
                    subtitle:"Tickets",
                    loading:false,
                    refresh:false,
                    download:false,
                    show_download:false,
                    close:false,
                },
                mvp:{
                    title:"MVP",
                    subtitle:"Projeto",
                    loading:false,
                    refresh:false,
                    download:false,
                    show_download:false,
                    close:false,
                },
                andamento:{
                    title:"Andamento",
                    subtitle:"PGD",
                    loading:false,
                    refresh:false,
                    download:false,
                    show_download:false,
                    close:false,
                },
                media_tempo:{
                    title:"Média de Tempo",
                    subtitle:"Tickets",
                    loading:false,
                    refresh:false,
                    download:false,
                    show_download:false,
                    close:false,
                },
                produtividade:{
                    title:"Produtividade",
                    subtitle:"Analistas",
                    loading:false,
                    refresh:false,
                    download:false,
                    show_download:false,
                    close:false,
                },
                qualidade_aprovado: {
                    title:"Estatísticas de Testes",
                    subtitle:"Aprovados",
                    loading:false,
                    refresh:false,
                    download:false,
                    show_download:false,
                    close:false,
                },
                qualidade_reprovado: {
                    title:"Estatísticas de Testes",
                    subtitle:"Reprovados",
                    loading:false,
                    refresh:false,
                    download:false,
                    show_download:false,
                    close:false,
                },
                incidentes:{
                    title:"Estatísticas de testes",
                    subtitle:"tickets - erros pré-qualidade",
                    loading:false,
                    refresh:false,
                    download:false,
                    show_download:false,
                    close:false,
                },
                ranque:{
                    title:"Estatísticas de testes",
                    subtitle:"Ranque - Programador X bug",
                    loading:false,
                    refresh:false,
                    download:false,
                    show_download:false,
                    close:false,
                },
                reabertura:{
                    title:"Reabertura",
                    subtitle:"Tickets",
                    loading:false,
                    refresh:false,
                    download:false,
                    show_download:false,
                    close:false,
                }
            }   
        }),
    }
</script>
